/**
 * iVCEBlast Application Configuration
 */

import type { ChartImage, DropdownOption, LivePlotImageOptions, LivePlotSizeOptions, PlotSpec, PrintChartAspect, RichSummary } from '../shared';

export const APP_NAME = 'iVCEBlast';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

export const CONFINEMENT_OPTIONS: DropdownOption[] = [
  { value: 'Confined', label: 'Confined' },
  { value: 'UnConfined', label: 'UnConfined' }
];

export interface APIPayload {
  title: string;
  mass: string;
  LHV: string;
  mf: string;
  R: string;
  Confinement: string;
  V: string;
  A: string;
}

export type ChartKey = 'pressure' | 'impulse';

export const PRINT_CHART_ORDER: ChartKey[] = ['pressure', 'impulse'];

export const PRINT_CHART_ASPECT = {
  pressure: 'square',
  impulse: 'square'
} satisfies Record<ChartKey, PrintChartAspect>;

export const PRINT_CHART_IMAGE_OPTIONS: Record<PrintChartAspect, LivePlotImageOptions> = {
  wide: {
    width: 600,
    height: 400,
    scale: 2,
    layout: {
      font: { size: 16 },
      title: { font: { size: 28 } },
      margin: { l: 86, r: 28, t: 72, b: 108 },
      xaxis: { title: { font: { size: 18 } }, tickfont: { size: 14 } },
      yaxis: { title: { font: { size: 18 } }, tickfont: { size: 14 } },
      legend: { font: { size: 16 }, x: 0.5, xanchor: 'center', y: -0.32 }
    }
  },
  square: {
    width: 500,
    height: 500,
    scale: 2,
    layout: {
      font: { size: 15 },
      title: { font: { size: 20 } },
      margin: { l: 88, r: 28, t: 78, b: 114 },
      xaxis: { title: { font: { size: 17 } }, tickfont: { size: 13 } },
      yaxis: { title: { font: { size: 17 } }, tickfont: { size: 13 } },
      legend: { font: { size: 13 }, x: 0.5, xanchor: 'center', y: -0.32 }
    }
  }
};

export const LIVE_PLOT_CARD_MIN_HEIGHT = 'clamp(20rem, 72vw, 34rem)';

export const LIVE_PLOT_SIZE_BY_KEY = {
  pressure: {
    fit: 'width',
    width: '100%',
    maxWidth: '38rem',
    aspectRatio: '1 / 1'
  },
  impulse: {
    fit: 'width',
    width: '100%',
    maxWidth: '38rem',
    aspectRatio: '1 / 1'
  }
} satisfies Record<ChartKey, LivePlotSizeOptions>;

export interface APIResponse {
  summary: RichSummary;
  plotData: Partial<Record<ChartKey, PlotSpec>>;
}

// Plotly chart images are generated client-side for print/save.
export type VCEBlastResultState = APIResponse & {
  charts?: Partial<Record<ChartKey, ChartImage>>;
};
